import { FC } from 'react'
import Layout from 'components/layout/Layout'
import { serverSideTranslations } from 'next-i18next/serverSideTranslations'
import Encyclopedia from 'features/encyclopedia/Encyclopedia'
import { EncyclopediaProps as Props } from 'features/encyclopedia/types'
import { getEncyclopediaArticles, getEncyclopediaCategories, getEncyclopediaLandingsPage } from 'api/encyclopedia'

const EncyclopediaPage: FC<Props> = (props) => {
  return (
    <Layout>
      <Encyclopedia {...props} />
    </Layout>
  )
}

export const getStaticProps = async ({ locale }) => {
  try {
    // fetch Articles & Categories
    const [content, categories, articles] = await Promise.all([
      getEncyclopediaLandingsPage(),
      getEncyclopediaCategories(),
      getEncyclopediaArticles()
    ])

    return {
      props: {
        articles,
        categories,
        content,
        ...(await serverSideTranslations(locale))
      },
      revalidate: 10 // re-generate page when a request comes in, once every 10 seconds
    }
  } catch (error) {
    return {
      props: {
        articles: [],
        categories: []
      },
      revalidate: 10 // re-generate page when a request comes in, once every 10 seconds
    }
  }
}

export default EncyclopediaPage
